import {
  createContext,
  ReactNode,
  useEffect,
  useLayoutEffect,
  useState,
} from "react";
import { getSubdomain } from "../utils/getSubdomain";
import { fetchSite, TApiSiteResult } from "../utils/api/fetchSite";
import TApiResult from "../types/api/TApiResult";
import setManifestURL from "../utils/generageManifest";
import setFaviconURL from "../utils/setFaviconURL";
import { Helmet } from "react-helmet";
import getImageUrl from "../utils/getImageUrl";
import PAGE_CONFIG from "../config/page";

export type SiteContextType = {
  name: string;
  isPoint: boolean;
  isPublic: boolean;
  tenantId: string;
  googleAnalyticsId?: string;
  enablesHomePopup: boolean;
  homePopupDescription?: string;
};

export const SiteContext = createContext({} as SiteContextType);

export const SiteProvider = (props: { children: ReactNode }) => {
  const { children } = props;
  const [tenantId, setTenantId] = useState<string>();
  const [isPoint, setIsPoint] = useState(false);
  const [isPublic, setIsPublic] = useState(false);
  const subdomain = getSubdomain(window.location.hostname);
  const [name, setName] = useState<string>("");
  const [googleAnalyticsId, setGoogleAnalyticsId] = useState<string>();
  const [enablesHomePopup, setEnablesHomePopup] = useState<boolean>(false);
  const [homePopupDescription, setHomePopupDescription] = useState<string>();

  const HeadForFavicons = () => (
    <Helmet>
      <link
        rel="icon"
        href={getImageUrl(
          subdomain,
          PAGE_CONFIG.IMAGE_URL_PATH.SITE,
          PAGE_CONFIG.FAVICON
        )}
      />
      <link
        rel="apple-touch-icon"
        href={getImageUrl(
          subdomain,
          PAGE_CONFIG.IMAGE_URL_PATH.SITE,
          PAGE_CONFIG.APPLE_TOUCH_ICON
        )}
      />
    </Helmet>
  );

  useEffect(() => {
    fetchSite().then((res: TApiResult & TApiSiteResult) => {
      if (!res.isSuccess || !res.result) return;
      setName(res.result.name);
      setTenantId(res.result.gcp_id);
      setManifestURL(res.result.name, subdomain);
      setIsPoint(res.result.is_point === 1);
      setIsPublic(res.result.is_public);
      setGoogleAnalyticsId(res.result.google_analytics_id);
      setEnablesHomePopup(res.result.enables_home_popup);

      const defaultDescription =
        "ホーム画面への追加はお済みですか？ \n簡単10秒設定で↓↓↓  \nさらに便利に活用いただけます！";
      const homePopupDescription =
        res.result.home_popup_description ?? defaultDescription;
      setHomePopupDescription(homePopupDescription);
    });
  }, [subdomain, tenantId]);
  if (subdomain === "") return <>subdomain is empty</>;
  if (!tenantId)
    return (
      <>
        <HeadForFavicons />
      </>
    );

  return (
    <SiteContext.Provider
      value={{
        name,
        isPoint,
        isPublic,
        tenantId,
        googleAnalyticsId,
        enablesHomePopup,
        homePopupDescription,
      }}
    >
      <HeadForFavicons />
      {children}
    </SiteContext.Provider>
  );
};
